import { render, staticRenderFns } from "./wearing.vue?vue&type=template&id=66c6e7ca&scoped=true&"
import script from "./wearing.vue?vue&type=script&lang=js&"
export * from "./wearing.vue?vue&type=script&lang=js&"
import style0 from "./wearing.vue?vue&type=style&index=0&id=66c6e7ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c6e7ca",
  null
  
)

export default component.exports